import React, { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import logo from '../assets/images/quizrr-logo.svg';

import Block from './Block';
import Container from './Container';
import HeaderLogo from './HeaderLogo';
import Backgrounder from './Backgrounder';
import CallOutArrow from './CallOutArrow';
import ContainerHeader from './ContainerHeader';

const PartnerLogo = styled.img`
  max-height: 40px;
  width: auto;
  max-width: 100%;

  ${breakpoint('tablet')`
    max-height: 60px;
  `};
`;

const SiteHeaderPartnerPage = ({ partnerLogo }) => {
  const partnerLogoRef = useRef();
  const [dimensions, setDimensions] = useState({});

  useLayoutEffect(() => {
    setDimensions(partnerLogoRef.current.getBoundingClientRect());
  }, [partnerLogoRef.current]);

  return (
    <ContainerHeader backgroundColor="blueDark" position="relative">
      <Backgrounder
        backgroundColor="white"
        position="left"
        width={`calc(((100% - 1160px) / 2) + ${dimensions.width}px)`}
      />

      <Container
        display="flex"
        position="relative"
        style={{
          height: '100%',
          display: 'flex',
        }}
      >
        <Block
          ref={partnerLogoRef}
          position="relative"
          backgroundColor="white"
          overflow="hidden"
          display="flex"
          alignItems="center"
          px="baseUnit"
          pr={{ mobile: 'baseUnit', tablet: 'baseUp4' }}
        >
          <PartnerLogo src={partnerLogo.url} />

          <CallOutArrow
            backgroundColor="white"
            position="left"
            color="white"
            display={{ mobile: 'none', tablet: 'block' }}
          />
        </Block>

        <Block
          flex="1"
          px="baseUnit"
          pl={{ mobile: 'baseUnit', tablet: 'baseUp8' }}
          style={{ alignSelf: 'center' }}
        >
          <HeaderLogo
            src={logo}
            height={{ mobile: '24px', smallTablet: '32px', tablet: '36px' }}
            style={{ width: 'auto' }}
            alt="Quizrr"
          />
        </Block>
      </Container>
    </ContainerHeader>
  );
};

SiteHeaderPartnerPage.propTypes = {
  partnerLogo: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default SiteHeaderPartnerPage;
